module.exports = __webpack_public_path__ + "img/people.6af0a3ed.png";